/* eslint-disable react-hooks/exhaustive-deps */
// @ts-ignore - CSS imports are handled by the project build tooling, not TS declarations.
import './sumary.scss';
import Grid from '@mui/material/Grid';
import React from 'react';
import { useAppDispatch } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import counselorServices from 'services/counselorServices';
import RCoursesAndGrades from 'screen/counselor/components/RCoursesAndGrades';
import { getAccessToken, getUserId, removeUserId, removeAccessToken } from 'utils/sessionStorage';
// import { ConversationCard } from './ReviewPersonal';
// import Cookies from 'js-cookie';
// import { authenticateSettings } from 'components/helper/appConfig';


const ReviewCourse = () => {
  const dispatch = useAppDispatch();
  const history = useHistory();  
  let studentId = getUserId();
  let token = getAccessToken();
  const [listCounselorConnection, setListCounselorConnection] = React.useState<any[]>([]);
  const [currentModuleId, setCurrentModuleId] = React.useState('5.1');

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };  

  const getData = () => {
    if (token && studentId) {
      counselorServices.getCounselors(studentId).then((res: any[]) => {
        setListCounselorConnection(res ?? []);
      });      
    }
    else {
      handleLogout();
    }    
  };

  React.useEffect(() => {
    getData();
    console.log('currentModuleId:', currentModuleId);
    console.log('listCounselorConnection:', listCounselorConnection);
  }, []);

  return (
    <Grid container sx={{ width: '100%' }}>
      <Grid item xs={12} md={8}>
        <RCoursesAndGrades setCurrentModuleId={setCurrentModuleId} />
      </Grid>
      {/* <Grid item xs={12} md={4} sx={{ marginTop: { md: '48px' } }}>
        {listCounselorConnection.map((item, index) => (
          <ConversationCard conversationItem={item} currentModuleId={currentModuleId} key={index} />
        ))}
      </Grid> */}
    </Grid>
  );
};

export default ReviewCourse;
